export default __webpack_public_path__ + "static/media/Simple-Line-Icons4c82.e44ce50c.svg";